import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, API } from "@/App";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Extract session_id from URL fragment
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get("session_id");

      if (!sessionId) {
        toast.error("Authentication failed - no session");
        navigate("/login");
        return;
      }

      try {
        const response = await fetch(`${API}/auth/session`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          throw new Error("Failed to authenticate");
        }

        const data = await response.json();
        login(data.user);
        
        // Clear the hash and navigate
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("Welcome to OurSpacez!");
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (error) {
        // Auth callback error - redirecting to login
        toast.error("Authentication failed");
        navigate("/login");
      }
    };

    processAuth();
  }, [navigate, login]);

  return (
    <div className="min-h-screen bg-[#FFF5E1] flex items-center justify-center">
      <div className="brutal-card text-center">
        <div className="animate-spin w-12 h-12 border-4 border-black border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-xl font-bold">Signing you in...</p>
      </div>
    </div>
  );
}
